(function () {
  'use strict';

  function deduplicateDrawerSvgIds(drawerMenu) {
    const svgs = drawerMenu.querySelectorAll('svg');
    let counter = 0;
    const urlAttrs = ['fill', 'stroke', 'mask', 'filter', 'clip-path', 'marker-start', 'marker-mid', 'marker-end'];

    svgs.forEach(function (svg) {
      counter++;
      const suffix = '-sk' + counter;
      const idMap = {};

      svg.querySelectorAll('[id]').forEach(function (el) {
        const oldId = el.id;
        const newId = oldId + suffix;
        idMap[oldId] = newId;
        el.id = newId;
      });

      if (Object.keys(idMap).length === 0) return;

      svg.querySelectorAll('*').forEach(function (el) {
        urlAttrs.forEach(function (attr) {
          const val = el.getAttribute(attr);
          if (!val) return;
          const updated = val.replace(/url\(#([^)]+)\)/g, function (match, refId) {
            return idMap[refId] ? 'url(#' + idMap[refId] + ')' : match;
          });
          if (updated !== val) el.setAttribute(attr, updated);
        });

        ['xlink:href', 'href'].forEach(function (attr) {
          const val = el.getAttribute(attr);
          if (val && val.charAt(0) === '#') {
            const refId = val.slice(1);
            if (idMap[refId]) el.setAttribute(attr, '#' + idMap[refId]);
          }
        });
      });
    });
  }

  function initDrawerSubmenu() {
    const drawerMenu = document.querySelector('drawer-menu');
    if (!drawerMenu) return;

    const mainLevel = drawerMenu.querySelector('.drawer-menu__contents');
    if (!mainLevel) return;

    deduplicateDrawerSvgIds(drawerMenu);

    const level2Inputs = drawerMenu.querySelectorAll('.drawer-submenu__item__input');
    level2Inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        const accordion = input.closest('[data-accordion-item]');
        if (!accordion) return;

        if (input.checked) {
          level2Inputs.forEach(function (other) {
            if (other !== input && other.checked) {
              other.checked = false;
              const otherAccordion = other.closest('[data-accordion-item]');
              if (otherAccordion) otherAccordion.classList.remove('is-open');
            }
          });
          accordion.classList.add('is-open');
        } else {
          accordion.classList.remove('is-open');
        }
      });
    });

    const sub2CloseButtons = drawerMenu.querySelectorAll('[data-drawer-sub2-close]');
    sub2CloseButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();

        level2Inputs.forEach(function (input) {
          if (input.checked) {
            input.checked = false;
            const accordion = input.closest('[data-accordion-item]');
            if (accordion) accordion.classList.remove('is-open');
          }
        });

        const parentPanelId = button.getAttribute('data-panel-id');
        if (parentPanelId) {
          const parentInput = document.getElementById(parentPanelId);
          if (parentInput) parentInput.focus();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawerSubmenu);
  } else {
    initDrawerSubmenu();
  }
})();
